export default __webpack_public_path__ + "static/media/porch.ba8c5bc9.jpeg";